import BASE_PATH from "@/config/basePath";

/**
 * 校验并归一化登录后的 redirect 目标。
 *
 * redirect 参数有三个来源：middleware.ts 未登录拦截时写入的 pathname、
 * 跨站跳转（DetectionIp）带过来的落地路径、以及用户自己在 URL 上拼的任意值。
 * 前两者可信，第三者不可信 —— 原实现只判断 startsWith("/pointsmall")，
 * 之后直接交给 router.replace() / window.location.href，等于把跳转目标
 * 完全交给攻击者：?redirect=//evil.com 这类协议相对 URL 会被浏览器当成
 * 外部主机，形成开放重定向（钓鱼时可借本站域名做跳板）。
 *
 * 这里只接受「单斜杠开头的站内路径」，其余一律退回首页：
 *   /cart                 → 放行
 *   /pointsmall/sc/user   → 放行
 *   //evil.com            → 拒（协议相对 URL）
 *   https://evil.com      → 拒（绝对 URL）
 *   \\evil.com            → 拒（部分浏览器等价于 //）
 *   javascript:alert(1)   → 拒
 */
export function safeRedirectPath(raw: unknown, fallback = "/"): string {
  if (typeof raw !== "string" || raw.length === 0) return fallback;

  // 反斜杠有浏览器会按 / 解析，先归一再判断，避免 \\evil.com 绕过
  const path = raw.replace(/\\/g, "/");

  if (!path.startsWith("/")) return fallback; // 相对路径、绝对 URL、scheme 一律拒
  if (path.startsWith("//")) return fallback; // 协议相对 URL → 外部主机

  return path;
}

/** 目标是否为带 basePath 的完整站内路径（决定整页跳转还是 router 跳转） */
export function isBasePathAbsolute(path: string): boolean {
  return path === BASE_PATH || path.startsWith(`${BASE_PATH}/`);
}
